import { Descriptions, Typography } from "antd";
import type {
  KycQuestionnaireAnswerFragment,
  KycQuestionnaireQuestionFragment,
} from "../../graphql";

const { Text, Link: AntLink } = Typography;

function findQuestion(
  questions: KycQuestionnaireQuestionFragment[],
  questionId: string,
) {
  return questions.find((q) => q._id === questionId);
}

function renderAnswer(answer: KycQuestionnaireAnswerFragment) {
  switch (answer.type) {
    case "SINGLE_CHOICE":
      return <Text>{answer.selectedOption ?? "-"}</Text>;
    case "MULTIPLE_CHOICE":
      return (
        <Text>
          {answer.selectedOptions?.length
            ? answer.selectedOptions.join(", ")
            : (answer.selectedOption ?? "-")}
        </Text>
      );
    case "FREE_TEXT":
      return <Text>{answer.textValue ?? "-"}</Text>;
    case "NUMBER":
      return <Text>{answer.numberValue?.toLocaleString() ?? "-"}</Text>;
    case "DATE":
      return (
        <Text>
          {answer.dateValue
            ? new Date(answer.dateValue).toLocaleDateString("mn-MN")
            : "-"}
        </Text>
      );
    case "FILE_UPLOAD":
      return answer.fileUrl ? (
        <AntLink href={answer.fileUrl} target="_blank">
          {answer.fileName ?? "Файл харах"}
        </AntLink>
      ) : (
        <Text>-</Text>
      );
    default:
      return <Text>-</Text>;
  }
}

export const ResponseView = ({
  answers,
  questions,
}: {
  answers: KycQuestionnaireAnswerFragment[];
  questions: KycQuestionnaireQuestionFragment[];
}) => {
  return (
    <Descriptions bordered column={1} size="small">
      {answers.map((answer, index) => {
        const question = findQuestion(questions, answer.questionId);
        return (
          <Descriptions.Item
            key={index}
            label={question?.question ?? `Асуулт ${index + 1}`}
          >
            {renderAnswer(answer)}
          </Descriptions.Item>
        );
      })}
    </Descriptions>
  );
};
